module.exports = __webpack_public_path__ + "img/r8.f5062a11.jpg";